$(document).ready(function () {
  $(".search-toggle .amphiicon").click(function () {
    $(".searchbox-wrapper").addClass("active");
    $("html").addClass("active-search-overlay");
  });
  $(".searchbox-closeIcon .amphiicon").click(function () {
    $(".searchbox-wrapper").removeClass("active");
    $("html").removeClass("active-search-overlay");
  });

  $(".module-style__news-layout:not(.template-2-news-per-row-image-top-text-bottom, .template-2-news-per-row-image-top-text-bottom-wall, .template-3-news-per-row-image-top-text-bottom, .template-3-news-per-row-image-top-text-bottom-wall, .template-4-news-per-row-image-top-text-bottom, .template-4-news-per-row-image-top-text-bottom-wall, .template-slideshow) .newsDate .group-name").after("<br />");

  $(".module-style__news-layout.template-2-news-per-row-image-top-text-bottom .module-content-block, .module-style__news-layout.template-2-news-per-row-image-top-text-bottom-wall .module-content-block, .module-style__news-layout.template-3-news-per-row-image-top-text-bottom .module-content-block, .module-style__news-layout.template-3-news-per-row-image-top-text-bottom-wall .module-content-block, .module-style__news-layout.template-4-news-per-row-image-top-text-bottom .module-content-block, .module-style__news-layout.template-4-news-per-row-image-top-text-bottom-wall .module-content-block, .module-style__news-layout.template-slideshow .module-content-block").each(function () {
    var $moduleContentBlock = $(this);
    var $thumbnail = $moduleContentBlock.find(".thumbnail");
    var $caption = $thumbnail.find(".caption");
    var hasImageOrSvg = $thumbnail.find("img").length > 0 || $thumbnail.hasClass("svg-amphiicon");

    if (!$thumbnail.length || ($caption.length && !hasImageOrSvg)) {
      $moduleContentBlock.find(".newsDate .group-name").after("<br />");
    }
  });
});

$(window).load(function () {
  $(".searchbox-wrapper").removeClass("hide");
});

nc_initAccessibilityFontSizeChanger('.font-size-changer');

nc_initScrollClass('header', 'header', 'fixed');